var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { inject } from "tsyringe";
import { Availability } from "../Availability";
import { ExtraFeeTypes } from "../Menu";
import { IdMap } from "../../collections";
import { FulfillmentInstructions, FulfillmentInstructionsToken, } from "../FulfillmentInstructions";
import { isAddedAtCompatible } from "../PackagingFeeCompatibility";
let ProductTypePackagingFeeAvailabilityService = class ProductTypePackagingFeeAvailabilityService {
    constructor(extraFeeTypes, fulfillmentInstructions) {
        this.extraFeeTypes = extraFeeTypes;
        this.fulfillmentInstructions = fulfillmentInstructions;
        makeImmutable(this);
    }
    possiblePackagingFeeTypes(productInstance) {
        const fulfillmentMethod = this.fulfillmentInstructions.fulfillmentMethod;
        return this.extraFeeTypes.filter((packagingFeeType) => packagingFeeType.requirements.testProduct(productInstance) &&
            isAddedAtCompatible(packagingFeeType.addedAt, fulfillmentMethod));
    }
    availability(productInstance) {
        const possibleFees = this.possiblePackagingFeeTypes(productInstance);
        const feeId = productInstance.productPackagingFeeId;
        return Availability.boolean({
            ProductPackagingFee: (!possibleFees.isEmpty && feeId === null) ||
                (feeId !== null && !possibleFees.includes(feeId)),
        });
    }
};
ProductTypePackagingFeeAvailabilityService = __decorate([
    perRestaurant(),
    __param(0, inject(ExtraFeeTypes)),
    __param(1, inject(FulfillmentInstructionsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof IdMap !== "undefined" && IdMap) === "function" ? _a : Object, typeof (_b = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _b : Object])
], ProductTypePackagingFeeAvailabilityService);
export { ProductTypePackagingFeeAvailabilityService };
